import { mdiImage } from '@lumapps/lumx/icons';

export const WIDGET_FEATURED_IMAGE_TYPE = 'featured-image';
export const WIDGET_FEATURED_IMAGE_EDITION_SCOPE = 'widget-featured-image-edition';
export const WIDGET_FEATURED_IMAGE_ICON = mdiImage;

export const CLASSNAME = 'widget-featured-image';
